import { render } from "./DiasCreditoForm.vue?vue&type=template&id=5274a2fe&scoped=true"
import script from "./DiasCreditoForm.vue?vue&type=script&lang=js"
export * from "./DiasCreditoForm.vue?vue&type=script&lang=js"

import "./DiasCreditoForm.vue?vue&type=style&index=0&id=5274a2fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5274a2fe"]])

export default __exports__